// extracted by mini-css-extract-plugin
export var standaloneTable = "_g0-0";
export var standaloneTableWithBodyFill = "_g0-1";
export var withExtraHeader = "_g0-2";